export default "__VITE_ASSET__d39f76ee__"